(() => {
  const supportsDesktopCursor = window.matchMedia(
    '(min-width: 750px) and (hover: hover) and (pointer: fine)'
  );
  if (!supportsDesktopCursor.matches) return;

  if (document.querySelector('.cursor-follower')) return;

  const follower = document.createElement('div');
  follower.className = 'cursor-follower';
  follower.setAttribute('aria-hidden', 'true');
  document.body.appendChild(follower);

  const interactiveSelector =
    'a, button, input, select, textarea, summary, label, [role="button"], [tabindex]:not([tabindex="-1"])';

  let targetX = 0;
  let targetY = 0;
  let currentX = 0;
  let currentY = 0;
  let hasPosition = false;
  let frame;

  const render = () => {
    currentX += (targetX - currentX) * 0.22;
    currentY += (targetY - currentY) * 0.22;
    follower.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%)`;
    frame = window.requestAnimationFrame(render);
  };

  document.addEventListener(
    'mousemove',
    (event) => {
      targetX = event.clientX;
      targetY = event.clientY;

      if (!hasPosition) {
        currentX = targetX;
        currentY = targetY;
        hasPosition = true;
        frame = window.requestAnimationFrame(render);
      }

      follower.classList.add('is-visible');
      follower.classList.toggle('is-interactive', Boolean(event.target.closest(interactiveSelector)));
    },
    { passive: true }
  );

  document.addEventListener('mousedown', () => follower.classList.add('is-pressed'));
  document.addEventListener('mouseup', () => follower.classList.remove('is-pressed'));

  document.documentElement.addEventListener('mouseleave', () => {
    follower.classList.remove('is-visible', 'is-interactive', 'is-pressed');
  });

  document.documentElement.addEventListener('mouseenter', () => {
    if (hasPosition) follower.classList.add('is-visible');
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      follower.classList.remove('is-visible');
      if (frame) window.cancelAnimationFrame(frame);
      frame = undefined;
      hasPosition = false;
    }
  });
})();
